import { View, StyleSheet, Text } from '@react-pdf/renderer'

const primaryFontSize = 9

const styles = StyleSheet.create({
  table: {
    width: '100%',
    marginTop: 2 
  },
  header: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f1f3f9',
    color: '#000',
    padding: 3,
    borderRadius: '6px',
  },
  headerCell: {
    fontWeight: 'heavy',
    white: '#fff',
    width: '10.11%',
    fontSize: primaryFontSize
  },
  body: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row-reverse',
    padding: '10px',
    flexDirection: 'column',
    backgroundColor: '#f1f3f93d'
  },
  cell: {
    width: '10.11%'
  },
  row: {
    display: 'flex',
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: 'space-between',
    padding: '5px 3px'
  }
})

const Table = ({ children }) => <View style={styles.table}>{children}</View>

const TableHeader = ({ children }) => (
  <View style={styles.header}>{children}</View>
)

const TableHeaderCell = ({ children }) => (
  <Text style={styles.headerCell}>{children}</Text>
)

const TableBody = ({ children }) => <View style={styles.body}>{children}</View>

const TableRow = ({ children }) => <View style={styles.row}>{children}</View>

const TableCell = ({ children }) => <Text style={styles.cell}>{children}</Text>

Table.Header = TableHeader
Table.Body = TableBody
Table.Row = TableRow
Table.HeaderCell = TableHeaderCell
Table.Cell = TableCell

export default Table